import { render } from "./PointSystemSettings.vue?vue&type=template&id=2a66d9f1&scoped=true"
import script from "./PointSystemSettings.vue?vue&type=script&lang=js"
export * from "./PointSystemSettings.vue?vue&type=script&lang=js"

import "./PointSystemSettings.vue?vue&type=style&index=0&id=2a66d9f1&scoped=true&lang=css"
import "./PointSystemSettings.vue?vue&type=style&index=1&id=2a66d9f1&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a66d9f1"]])

export default __exports__